import { createConfigProvider } from '@global-website/library';

import { ConfigContext } from './Context';

export const ConfigProvider = createConfigProvider(ConfigContext);
